<template>
  <div class="app-item">
    <b-row class="row-name">
      <b-col class="col-12 item-name">
        <label>
          <slot name="lblName"></slot>
        </label>
        <span>{{ item.name }}</span>
      </b-col>
    </b-row>
    <b-row class="row-consumptions" v-if="showConsumptions">
      <b-col class="col-12 consumptions">
        <ConsumptionList :consumptions="item.consumptions" :isFlatrate="isAllNetFlat">
          <template v-for="slot in possibleChildSlotsFor('ConsumptionsList')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ConsumptionList>
      </b-col>
    </b-row>
    <b-row class="row-info">
      <b-col class="col-6 item-info">
        <div class="status">
          <label>
            <slot name="lblStatus">Status: </slot>
          </label>
          <span :class="inactive">{{ status }}</span>
        </div>
        <div class="state">
          <label>
            <slot name="lblExtend">Verlängerung: </slot>
          </label>
          <span :class="[futureInactive, inactive]">{{extension}}</span>
        </div>
        <div class="price">
          <label>
            <slot name="lblPrice">Kosten: </slot>
          </label>
          <span>{{ priceDuration || 'keine' }}</span>
        </div>
      </b-col>
      <b-col class="col-6 buttons">
        <Buttons @selected="selected" @refresh="$emit('refresh')" :item="item" ref="buttons" :item-type="itemType"></Buttons>
      </b-col>
    </b-row>
    <b-row class="row-extra-info">
      <b-col class="col-12 item-extra-info">
        <p class="item-extra-info-label">
          <a @click="visible = !visible">
            <slot name="txtToggleOpen" v-if="visible">- zusätzliche Infos ausblenden</slot>
            <slot name="txtToggleClosed" v-if="!visible">- zusätzliche Infos einblenden</slot>
          </a>
        </p>
        <b-collapse id="collapseInfo" v-model="visible">
          <b-card>
            <div v-html="this.item.extraInfoOrdering"></div>
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import Buttons from './Buttons.vue'
import slotProxy from '../../../../../mixins/slotProxy'
import ConsumptionList from '../../Consumption/ConsumptionList.vue'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'Item',
  components: { ConsumptionList, Buttons },
  mixins: [
    slotProxy()
  ],
  data () {
    return {
      visible: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('tariffs', [
      'initiateCancelTariff',
      'initiateCancelTariffOption'
    ]),
    ...mapMutations('tariffs', [
      'changeView'
    ]),
    async selected () {
      this.$refs.buttons.changeLoading(true)
      if (!this.item.isPendingTariff && this.item.tariffId) { // only un booked tariff
        this.$emit('selected', this.item)
        await this.initiateCancelTariff().then((response) => {
          if (response) {
            this.$refs.buttons.changeLoading(false)
            this.changeView({ view: 'deactivate' })
          }
        }, () => {
          this.$refs.buttons.changeLoading(false)
        })
      } else if (!this.item.isPendingTariff && this.item.tariffoptionId) {
        this.$emit('selected', this.item)
        await this.initiateCancelTariffOption({ tariffoptionId: this.item.tariffoptionId }).then((response) => {
          if (response) {
            this.$refs.buttons.changeLoading(false)
            this.changeView({ view: 'deactivate' })
          }
        }, () => {
          this.$refs.buttons.changeLoading(false)
        })
      } else {
        this.$refs.buttons.changeLoading(false)
        this.changeView({ view: 'deactivate' })
        this.$emit('selected', this.item)
      }
    }
  },
  computed: {
    priceDuration: function () {
      const format = (formattedPrice, runtime) => {
        let amount = runtime.amount
        if (amount === 1) {
          amount = ''
        } else {
          amount += ' '
        }
        return formattedPrice + ' / ' + amount + runtime.formattedUnit
      }
      if (this.itemType === 'tariffOption') {
        return format(this.item.formattedPrice, this.item.duration)
      } else if (this.itemType === 'bookedTariff' || this.itemType === 'pendingTariff') {
        return format(this.item.formattedBasicFee, this.item.runtime)
      } else if (this.itemType === 'serviceOption') {
        return 'kostenlos'
      }
      return 'keine'
    },
    status: function () {
      const flag = this.item.statusKey
      if (this.itemType === 'bookedTariff' && this.hasPendingNotTerminated) {
        return 'aktiv'
      }
      if (this.itemType === 'bookedTariff' || this.itemType === 'tariffOption') {
        switch (flag) {
          case 'IDL':
          case 'PDL':
            return 'Buchung in Bearbeitung'
          case 'TER':
          case 'CDL':
            return 'aktiv'
          case 'SUS':
            return 'inaktiv'
          default:
            return 'keiner'
        }
      } else if (this.itemType === 'pendingTariff') {
        return 'vorgemerkt'
      } else if (this.itemType === 'serviceOption') {
        return 'aktiv'
      }
      return 'keiner'
    },
    extension: function () {
      const flag = this.item.statusKey
      if (this.itemType === 'bookedTariff' && this.hasPendingNotTerminated) {
        return 'Deaktiviert zum' + this.item.possibleChangingDate
      }
      if (this.itemType === 'tariffOption' && !this.item.automaticExtension) {
        return 'Wird automatisch beendet zum ' + this.item.possibleChangingDate
      }
      if (this.itemType === 'bookedTariff' || this.itemType === 'tariffOption') {
        switch (flag) {
          case 'IDL' || 'PDL':
            return 'Buchung in Bearbeitung'
          case 'CDL':
            return 'Verlängert sich automatisch am ' + this.item.possibleChangingDate
          case 'TER':
            return 'Deaktiviert zum ' + this.item.possibleChangingDate
          case 'SUS':
            return 'Wird aktiviert sobald dein Guthaben ausreicht.'
          default:
            return 'keine'
        }
      } else if (this.itemType === 'pendingTariff') {
        return 'Wird aktiviert zum ' + this.item.possibleChangingDate
      } else if (this.itemType === 'serviceOption') {
        return 'unbefristet gültig'
      }
      return 'keine'
    },
    inactive () {
      if (this.item.statusKey === 'SUS') return 'color-red'
      return ''
    },
    futureInactive () {
      if (this.item.statusKey === 'TER' || (this.itemType === 'tariffOption' && !this.item.automaticExtension) || (this.itemType === 'bookedTariff' && this.hasPendingNotTerminated)) return 'color-red'
      return ''
    },
    hasPendingNotTerminated () {
      return this.hasPending && this.item.statusKey !== 'TER'
    },
    isAllNetFlat () {
      return this.item.phoneFlat === 'all' && this.item.smsFlat === 'all'
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    itemType: {
      type: String,
      required: true
    },
    hasPending: {
      type: Boolean,
      default: false
    },
    showConsumptions: {
      type: Boolean,
      default: true
    }
  }
}
</script>
